import EntregaTab from './EntregaTab'
import './EntregaTab.css'

export default EntregaTab